<template>
  <div>
    <NavBar />
    <ContactForm />
    <ConnectWithMe />
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import ContactForm from "../components/ContactForm.vue";
import ConnectWithMe from "../components/ConnectWithMe.vue";

export default {
  name: "Contact",
  components: {
    NavBar,
    ContactForm,
    ConnectWithMe,
  },
};
</script>

<style></style>
